import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';

const PrivateRoute = ({
  component: Component,
  unauthorisedComponent: UnauthorisedComponent,
  isAuthenticated,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => (
      isAuthenticated ?
        <Component {...props} /> :
        <UnauthorisedComponent {...props} />
    )}
  />
);

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
  ]).isRequired,
  unauthorisedComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.element,
  ]).isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  location: PropTypes.shape().isRequired,
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default withRouter(connect(mapStateToProps)(PrivateRoute));



// WEBPACK FOOTER //
// ./src/components/PrivateRoute/PrivateRoute.jsx